import { Action, State } from "./type";

const updateStateIfChanged = <K extends keyof State>(
  state: State,
  field: K,
  value: State[K]
): State => {
  if (state[field] === value) {
    return state;
  }
  return { ...state, [field]: value };
};

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "SET_THEME":
      return updateStateIfChanged(state, "theme", action.payload.theme);
    case "SET_LOCALE":
      return updateStateIfChanged(state, "locale", action.payload);
    case "SET_LOCALELINK":
      return updateStateIfChanged(state, "localeLink", action.payload);
    case "SET_DRAWEROPEN":
      return updateStateIfChanged(state, "drawerOpen", action.payload);
    case "SET_ISSTICKY":
      return updateStateIfChanged(state, "isSticky", action.payload);
    case "INIT_STATE":
      return action.payload;
    case "SET_COUNTRY":
      return updateStateIfChanged(state, "country", action.payload);
    default:
      return state;
  }
};

export default reducer;
